import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Company} from '../models/company';

@Injectable()
export class CustomCompanyService {

  constructor(private httpClient: HttpClient) {
  }

  addCompany(company) {
    return this.httpClient.post<Company>(environment.baseUrlWs + '/api/company', company);
  }

  getClientsLoasSchedules(): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/client-loa-schedule');
  }

  changeDadCompanySettings(dadCompanySetting: any, companyUniqid: string): Observable<any> {
    dadCompanySetting.company = companyUniqid;
    return this.httpClient.put<any>(environment.baseUrlWs + '/api/admin/dad-company-setting', dadCompanySetting);
  }

  loadUsersInfos() {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/users-info');
  }

  removeBillingAccount(billingAccountId): Observable<any> {
    return this.httpClient.delete<any>(environment.baseUrlWs + '/api/company/billing-account/' + billingAccountId);
  }

  syncWithSalesforce(): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/sync-with-salesforce');
  }
}
